var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaVitamins({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC260;}\n\t.st1{fill:#AA1A18;}\n\t.st2{fill:#F8EEE1;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,182.5c42.7,0,77.3-34.3,77.3-76.6s-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C27.9,148.2,62.5,182.5,105.2,182.5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.7,
    y: 68.9,
    className: "st1",
    width: 38.6,
    height: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.1,77.4H80.9c-5.3,0-9.6,4.3-9.6,9.6v46.2c0,5.3,4.3,9.6,9.6,9.6h46.2c5.3,0,9.6-4.3,9.6-9.6V87 C136.7,81.7,132.4,77.4,127.1,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.5,71.3h41c2.6,0,4.8-2.1,4.8-4.8V61c0-2.6-2.1-4.8-4.8-4.8h-41c-2.6,0-4.8,2.1-4.8,4.8v5.5 C78.7,69.2,80.9,71.3,83.5,71.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 88.9,
    className: "st2",
    width: 65.5,
    height: 40
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.6,112c2.5,4.3,2.9,9.2,1.7,13.6c-1.2,4.4-4.1,8.4-8.4,10.8L102.2,162c-0.7,0.4-1.5,0.8-2.3,1.1l17.4-10 c4.3-2.5,7.2-6.4,8.4-10.8c1.2-4.4,0.7-9.3-1.7-13.6c-4.5-7.8-14-11-22.1-7.8l27.3-15.6C137.8,100.4,148.7,103.4,153.6,112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124,128.7c2.4,4.3,2.9,9.2,1.7,13.6c-1.2,4.4-4.1,8.4-8.4,10.8l-17.4,10c-8.1,3.2-17.6,0.1-22.1-7.7 c-2.5-4.3-2.9-9.2-1.7-13.6c1.2-4.4,4.1-8.4,8.4-10.8l17.4-10C110,117.7,119.5,120.9,124,128.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaVitamins);
export default __webpack_public_path__ + "static/media/DNA_Vitamins.f70b5bad313941b0ed97da8c42f6738e.svg";
export { ForwardRef as ReactComponent };